import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpAuthenticationInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPAuthenticationInterceptor'
import HTTPExceptionInterceptor from '@/modules/shared/modules/http/domain/services/HTTPExceptionInterceptor'
import { httpTokenInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPTokenInterceptor'

import { PatientResponsibleList } from '../domain/models/PatientResponsible'
import { PatientDatasource } from '../infra/PatientDatasource'

export const patientDatasourceAdapter: PatientDatasource = {
  async getTherapistPatientList(personaId: string) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/personas/${personaId}/patients`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const data = await response.json()
    return data
  },
  async getOperatorPatientList() {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/operators/patients`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const data = await response.json()
    return data
  },
  async getResponsiblePatientList() {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/responsible/patients`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const data = await response.json()
    return data
  },
  async ListPatientResponsibles(patientId: string) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/responsible`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    return PatientResponsibleList.parse(await response.json())
  },
  async getPatient(id) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${id}`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )
    const data = await response.json()
    return data
  },
  async createPatient(data) {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients`,
          httpTokenInterceptor({
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          })
        )
      )
    )
  },
  async activatePatient(patientId) {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/activate`,
          httpTokenInterceptor({
            method: 'PATCH'
          })
        )
      )
    )
  },
  async deactivatePatient(patientId) {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/disable`,
          httpTokenInterceptor({
            method: 'PATCH'
          })
        )
      )
    )
  }
}
